import { HTTPMethod } from 'helpers/method';
import { ENDPOINT } from 'services/configs/endpoint.constant';

import {
  CreateUserPayload,
  EditUserPayload,
  GetListUserResponse,
  GetRolesResponse,
  UserResponse,
} from './user.type';
import { request } from '../configs/axiosConfig';

export const UserService = {
  getListUsers: async () => {
    return request<GetListUserResponse>({ method: HTTPMethod.GET, url: ENDPOINT.GET_LIST_USERS });
  },
  getListRoles: async () => {
    return request<GetRolesResponse>({ method: HTTPMethod.GET, url: ENDPOINT.GET_ROLES_USER });
  },
  createUser: async (data: CreateUserPayload) => {
    return request<UserResponse>({ method: HTTPMethod.POST, url: ENDPOINT.CREATE_USER, data });
  },
  editUser: async (id: string, data: EditUserPayload) => {
    return request<UserResponse>({
      method: HTTPMethod.PUT,
      url: `${ENDPOINT.UPDATE_USER}/${id}`,
      data,
    });
  },
  deleteUser: async (id: string) => {
    return request({ method: HTTPMethod.DELETE, url: `${ENDPOINT.DELETE_USER}/${id}` });
  },
  changeLocale: async (locale: string) => {
    return request({
      method: HTTPMethod.PUT,
      url: ENDPOINT.CHANGE_LOCALE_USER,
      data: { locale },
    });
  },
};
